<template>
  <div class="container" v-if="cardsListReady && !!bill">
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="bsd-section">
          <breadcrumb />
        </div>

        <div class="bsd-section">
          <div class="z-title z-title--small spacer-bottom-l">
            Escolha um cartão para pagar a mensalidade de {{ billTitle }}
          </div>

          <alert-box ref="alertBox" class="spacer-bottom-l" />

          <price-card :full-value="parseFloat(bill.bill_value)" :due-date="bill.due_date" />

          <card-list :cards="creditCards" @cardSelected="selectCard" @cardRemoved="loadCards" />

          <router-link
            tag="button"
            :to="{ name: 'nb-new-credit-card'}"
            class="z-button z-button--secondary z-button--block"
          >
            Adicionar novo cartão de crédito
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AlertBox from 'components/zilla/alert-box';
import Breadcrumb from 'components/breadcrumb';
import PriceCard from 'components/price-card';
import CardList from 'components/card-list';
import { mapActions, mapState, mapGetters } from 'vuex';
import CardPaymentService from 'services/CardPaymentService';
import DashboardService from 'services/DashboardService';

export default {
  components: {
    AlertBox,
    Breadcrumb,
    CardList,
    PriceCard,
  },
  data() {
    return {
      bill: {},
      cardsListReady: false,
    };
  },
  computed: {
    ...mapState([
      'currentBilling',
      'studentCards',
    ]),
    ...mapGetters([
      'getBillFromNotPaidBills',
    ]),
    billId() {
      return parseInt(this.$route.params.billId, 10);
    },
    creditCards() {
      return this.studentCards.filter((card) => card.card_type === 'credit_card');
    },
    reenrollmentBill() {
      return this.bill.metadata && this.bill.metadata.reenrollment_id;
    },
    billTitle() {
      if (this.reenrollmentBill) return `${this.bill.month_name} (Rematrícula)`;

      return this.bill.month_name;
    },
  },
  methods: {
    ...mapActions([
      'loadStudentCards',
    ]),
    selectCard(card) {
      this.$pageLoader.wrap(this.submitPayment(card), 'Processando pagamento');
    },
    submitPayment(card) {
      return CardPaymentService.charge(this.currentBilling.id, this.billId, card.id)
        .then((response) => {
          if (response.data.status === 'paid') {
            this.$router.replace({
              name: 'bill-payment-success',
              params: { billId: this.bill.id },
            });
          } else if (response.data.status === 'refused') {
            this.$refs.alertBox.show(
              'danger', 'Pagamento recusado',
              response.data.postback_message
                || 'Não foi possível efetuar o pagamento com o cartão selecionado. Tente utilizar outro cartão.',
            );
          } else {
            this.showUnexpectedErrorMessage();
          }
        })
        .catch(() => {
          this.showUnexpectedErrorMessage();
        });
    },
    showUnexpectedErrorMessage() {
      this.$refs.alertBox.show(
        'danger', 'Erro inesperado',
        'Não foi possível efetuar o pagamento. Tente novamente ou entre em contato com o Quero Pago.',
      );
    },
    checkBillAvailability() {
      if (!this.bill) {
        DashboardService.getBill(this.billId).then((bill) => {
          this.bill = bill;
        });
      }
    },
    loadCards() {
      this.loadStudentCards().then(() => {
        if (this.creditCards.length === 0) {
          this.$router.push({ name: 'nb-new-credit-card' });
        } else {
          this.cardsListReady = true;
        }
      });
    },
  },
  created() {
    this.loadCards();
  },
  mounted() {
    this.bill = this.$store.getters.getBillFromNotPaidBills(this.billId);
    this.checkBillAvailability(); // get bill from the server if it's not in vuex
    this.$tracker.logEvent('Viewed Credit Card Payment Page');
  },
};
</script>
